import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MessageService } from 'src/app/services/message.service';
import { IconsComponent } from '../icons/icons.component';

@Component({
  selector: 'vti-notification',
  standalone: true,
  imports: [IconsComponent],
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  public closeModal(): void {
    this.messageService.hideMessage();
  }

  private readonly messageService = inject(MessageService);

  public visible = toSignal(this.messageService.messageVisible$, { initialValue: false });
  public type = computed(() => this.messageService.vtiMessage().type);
  public message = computed(() => this.messageService.vtiMessage().message);
  public overlay = signal<boolean>(false);
}
